export const apiCatalog = async <TData>(
  url: string,
  options: RequestInit,
): Promise<TData> => {
  // Temporary baseUrl, TODO: Use the real catalog URL
  const baseUrl =
    process.env.NEXT_PUBLIC_CATALOG_URL?.replace('/api', '') || '';
  // const baseUrl = 'http://catalog.localhost';
  const response = await fetch(`${baseUrl}${url}`, options);

  const json = await response.json();

  return {
    data: json,
    status: response.status,
    headers: response.headers,
  } as TData;
};
